import { PAGE_FORM, PAGE_ERROR, PAGE_DEBUG } from '../routes';
import { usePayloadStore } from '../stores/payload-store';
import { useRefetch } from '../composables/use-refetch';

export default async function processPayload({ to, router }) {
    const payload = usePayloadStore();

    // Query params always take precedence
    if (to.query.uuid && to.query.payload) {
        await payload.decryptPayload({
            uuid: to.query.uuid,
            payload: to.query.payload,
        });

        return router.replace({
            name: PAGE_FORM,
        });
    }

    // If instructed (e.g. error case): resolve the payload data again
    const { shouldRefetchEverythingOnReload } = useRefetch();
    if (shouldRefetchEverythingOnReload.value) {
        await payload.decryptPayload({
            uuid: payload.atsUserUuid,
            payload: payload.encryptedPayload,
        });

        shouldRefetchEverythingOnReload.value = false;

        return router.replace({
            name: PAGE_FORM,
        });
    }

    if (payload.successfullyResolved) return true;

    if (import.meta.env.MODE === 'development') return { name: PAGE_DEBUG };

    return {
        name: PAGE_ERROR,
    };
}
